import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface UIState {
  /** Whether the sidebar is open (desktop). */
  sidebarOpen: boolean;
  /** Whether the mobile drawer is open. */
  mobileDrawerOpen: boolean;
  toggleSidebar: () => void;
  setSidebarOpen: (open: boolean) => void;
  toggleMobileDrawer: () => void;
  setMobileDrawerOpen: (open: boolean) => void;
}

/**
 * UI state with localStorage persistence.
 *
 * Only `sidebarOpen` is persisted (desktop sidebar state).
 * The mobile drawer state is ephemeral and resets on each visit.
 */
export const useUIStore = create<UIState>()(
  persist(
    (set) => ({
      sidebarOpen: true,
      mobileDrawerOpen: false,
      toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),
      setSidebarOpen: (open) => set({ sidebarOpen: open }),
      toggleMobileDrawer: () =>
        set((state) => ({ mobileDrawerOpen: !state.mobileDrawerOpen })),
      setMobileDrawerOpen: (open) => set({ mobileDrawerOpen: open }),
    }),
    {
      name: 'dpv-ui-state',
      partialize: (state) => ({ sidebarOpen: state.sidebarOpen }),
    }
  )
);
